import * as React from 'react';

import { ILocalization } from 'bernie-l10n';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';

import { MultiItemStore } from 'stores/multi-item-store';

import { MitStep } from 'models/multi-item/multi-item-types';

import { CustomerNotifications } from 'components/common/customer-notifications';
import { MitHeader } from 'components/multi-item/multi-item-header';

interface PropertySummaryHeaderProps {
  classes?: string;
  l10n?: ILocalization;
  multiItem?: MultiItemStore;
  regionId?: string;
  startDate: string | null;
  endDate: string | null;
}

export const PropertySummaryHeader: React.FunctionComponent<PropertySummaryHeaderProps> = ({
  classes,
  l10n,
  multiItem,
  regionId,
  startDate,
  endDate,
}) => (
  <div className={classes}>
    <MitHeader {...{ l10n, multiItem, currentStepName: MitStep.ROOM }} />
    <CustomerNotifications
      location={CustomerNotificationLocation.AFTER_HEADER}
      regionId={regionId}
      startDate={startDate}
      endDate={endDate}
    />
  </div>
);
PropertySummaryHeader.displayName = 'PropertySummaryHeader';
